import { gql } from '@apollo/client/core'
import { projectThingFeedbackFragment } from '../fragments'

const updatePaletteFeedbackFragment = gql`
  ${projectThingFeedbackFragment}

  fragment UpdatePaletteFeedback on ProjectPaletteMutations {
    updateFeedback(input: $input) {
      record {
        id
        ...Feedback
      }
    }
  }
`
const updateProductFeedbackFragment = gql`
  ${projectThingFeedbackFragment}

  fragment UpdateProductFeedback on ProjectProductMutations {
    updateFeedback(input: $input) {
      record {
        id
        ...Feedback
      }
    }
  }
`
const updateImageFeedbackFragment = gql`
  ${projectThingFeedbackFragment}

  fragment UpdateImageFeedback on ProjectImageMutations {
    updateFeedback(input: $input) {
      record {
        id
        ...Feedback
      }
    }
  }
`
const updateMockupFeedbackFragment = gql`
  ${projectThingFeedbackFragment}

  fragment UpdateMockupFeedback on ProjectMockupMutations {
    updateFeedback(input: $input) {
      record {
        id
        ...Feedback
      }
    }
  }
`

const updateGenericThingFeedbackFragment = gql`
  ${projectThingFeedbackFragment}

  fragment UpdateGenericThingFeedback on ProjectGenericThingMutations {
    updateFeedback(input: $input) {
      record {
        id
        ...Feedback
      }
    }
  }
`

export const updateFeedbackMutations = {
  PALETTE: gql`
    ${updatePaletteFeedbackFragment}
    fragment Mutation on ProjectMutations {
      palette {
        ...UpdatePaletteFeedback
      }
    }
  `,
  PRODUCT: gql`
    ${updateProductFeedbackFragment}
    fragment Mutation on ProjectMutations {
      product {
        ...UpdateProductFeedback
      }
    }
  `,
  IMAGE: gql`
    ${updateImageFeedbackFragment}
    fragment Mutation on ProjectMutations {
      image {
        ...UpdateImageFeedback
      }
    }
  `,
  MOCKUP: gql`
    ${updateMockupFeedbackFragment}
    fragment Mutation on ProjectMutations {
      mockup {
        ...UpdateMockupFeedback
      }
    }
  `,
  GENERIC: gql`
    ${updateGenericThingFeedbackFragment}
    fragment Mutation on ProjectMutations {
      mockup {
        ...UpdateGenericThingFeedback
      }
    }
  `,
}
